import React from "react";

function IncidentLog() {
  return <div>Development In progress...</div>;
}

export default IncidentLog;
